export const URL_PATTERN = {
  help: "{{protocol}}://help.{{domain}}/mydpd/",
  home: "{{protocol}}://{{dpdEnv}}www.{{domain}}",
  "legacy.login": "{{protocol}}://{{dpdEnv}}www.{{domain}}/umslogon/public/doLogon.do",
  mydpd: "{{protocol}}://{{gcpEnv}}my.{{domain}}",
  "mydpd.apis": "{{protocol}}://apis.{{gcpEnv}}my.{{domain}}",
  "mydpd.login": "{{protocol}}://{{gcpEnv}}my.{{domain}}/logon",
  "mydpd.logout": "{{protocol}}://{{gcpEnv}}my.{{domain}}/logout",
  "mydpd.welcome": "{{protocol}}://{{gcpEnv}}my.{{domain}}/welcome",
  "mydpd.account.printing-settings": "{{protocol}}://{{gcpEnv}}my.{{domain}}/account/printing-settings",
  "mydpd.mypreferences": "{{protocol}}://{{gcpEnv}}my.{{domain}}/account/contact-details",
  "mydpd.myreports": "{{protocol}}://{{gcpEnv}}myreports.{{domain}}",
  shipping: "{{protocol}}://{{gcpEnv}}myshipments.{{domain}}",
  "shipping.apis": "{{protocol}}://apis.{{gcpEnv}}myshipments.{{domain}}",
  collections: "{{protocol}}://{{gcpEnv}}mycollections.{{domain}}/cc",
  "collections.apis": "{{protocol}}://apis.{{gcpEnv}}mycollections.{{domain}}/cc",
  "collections.create": "{{protocol}}://{{gcpEnv}}mycollections.{{domain}}/cc/create",
  deliveries: "{{protocol}}://{{gcpEnv}}mydeliveries.{{domain}}",
  "deliveries.apis": "{{protocol}}://apis.{{gcpEnv}}mydeliveries.{{domain}}",
  "pickup-returns": "{{protocol}}://{{gcpEnv}}myreturns.{{domain}}",
  "pickup-returns.apis": "{{protocol}}://apis.{{gcpEnv}}myreturns.{{domain}}",
  data: "{{protocol}}://{{gcpEnv}}myaddressbook.{{domain}}",
  "data.address-book": "{{protocol}}://{{gcpEnv}}myaddressbook.{{domain}}",
  "data.groups": "{{protocol}}://{{gcpEnv}}myaddressbook.{{domain}}/groups",
  "data.product-book": "{{protocol}}://{{gcpEnv}}myproductbook.{{domain}}/products",
  // start unnecessary
  "address-book": "{{protocol}}://{{gcpEnv}}myaddressbook.{{domain}}",
  "address-book.addresses": "{{protocol}}://{{gcpEnv}}myaddressbook.{{domain}}/addresses",
  "address-book.groups": "{{protocol}}://{{gcpEnv}}myaddressbook.{{domain}}/groups",
  "address-book.apis": "{{protocol}}://apis.{{gcpEnv}}myaddressbook.{{domain}}",
  "product-book.products": "{{protocol}}://{{gcpEnv}}myproductbook.{{domain}}/products",
  // end unnecessary
  "depot-finder": "{{protocol}}://{{dpdEnv}}www.{{domain}}/apps/depotfinder/index.jsp",
  "depot-finder.apis": "{{protocol}}://{{dpdEnv}}www.{{domain}}",
  "terms-and-conditions": "{{protocol}}://www.{{domain}}/ts-and-cs.jsp",
  "terms-of-use": "{{protocol}}://www.{{domain}}/terms-of-use.jsp",
  "privacy-policy": "{{protocol}}://www.{{domain}}/privacy_policy.jsp"
};